import { useQuery } from '@tanstack/react-query'
import { AdminApiService } from '../services/apiClient'
import { adminSocketService } from '../services/socketService'
import type { UserRole } from '../components/data/orderWorkflowData'

/**
 * ✅ PHASE 3: Optimized navigation counts hook
 * - Disables refetchInterval when Socket.IO is connected (real-time updates via socket)
 * - Falls back to polling when socket is disconnected
 */
export const useNavCounts = (role: UserRole, userId?: string) => {
  return useQuery({
    queryKey: ['nav-counts', role, userId ?? null],
    queryFn: () => AdminApiService.getNavigationCounts(),
    staleTime: 60_000,
    // ✅ OPTIMIZED: Disable polling when socket is connected (real-time updates)
    refetchInterval: () => adminSocketService.connected ? false : 60_000
  })
}

